import React, { useState, useEffect } from 'react';
import api from '../services/api';

const formatCurrency = (amount) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);

const ReceiptTemplate = ({ dealId, paymentId }) => {
  const [receiptData, setReceiptData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.getReceiptData(dealId, paymentId);
        setReceiptData(response);
      } catch (error) {
        console.error('Failed to fetch receipt data', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dealId, paymentId]);

  if (loading) {
    return <div className="p-8">Loading...</div>;
  }

  if (!receiptData) {
    return <div className="p-8">Failed to load receipt data.</div>;
  }

  const { payment, deal, vehicle } = receiptData;
  const previousBalance = parseFloat(deal.balance_due) + parseFloat(payment.amount);
  const remainingBalance = deal.balance_due;

  return (
    <div className="bg-white p-8 max-w-2xl mx-auto my-4 border">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold">Alexis Motorcar LLC</h1>
        <p>4001 W Alexis Rd, Toledo, OH 43623</p>
        <p>Phone: 419-242-1005</p>
        <h2 className="text-3xl font-bold text-gray-700 mt-4">RECEIPT</h2>
      </div>

      <div className="flex justify-between mb-8">
        <p><strong>Receipt #:</strong> {payment.id}</p>
        <p><strong>Date:</strong> {new Date(payment.payment_date).toLocaleDateString()}</p>
      </div>

      <div className="mb-8">
        <p><strong>Received From:</strong> {deal.buyer_name}</p>
        <p><strong>Payment For:</strong> {vehicle.year} {vehicle.make} {vehicle.model} (VIN: {vehicle.vin}, Stock#: {vehicle.stock_number})</p>
      </div>

      <table className="w-full mb-8">
        <tbody>
          <tr className="border-t"><td className="p-2">Previous Balance</td><td className="text-right p-2">{formatCurrency(previousBalance)}</td></tr>
          <tr><td className="p-2">Amount Received</td><td className="text-right p-2">{formatCurrency(payment.amount)}</td></tr>
          <tr className="border-t-2 border-black"><td className="p-2 font-bold">Remaining Balance</td><td className="text-right p-2 font-bold">{remainingBalance > 0 ? formatCurrency(remainingBalance) : 'PAID IN FULL'}</td></tr>
        </tbody>
      </table>

      <div className="mb-8">
        <p><strong>Payment Method:</strong> {payment.payment_method}</p>
        {payment.reference_number && <p><strong>Reference #:</strong> {payment.reference_number}</p>}
      </div>

      <div className="text-center font-bold mt-8">
        <p>Thank you for your business!</p>
      </div>

      <div className="mt-12">
        <div className="w-1/2 border-t border-black pt-2">
          Signature
        </div>
      </div>
    </div>
  );
};

export default ReceiptTemplate;
